var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_5792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.586738 9.89327L3.16674 12.4999C3.22871 12.5624 3.30245 12.612 3.38369 12.6459C3.46493 12.6797 3.55206 12.6971 3.64007 12.6971C3.72808 12.6971 3.81522 12.6797 3.89646 12.6459C3.97769 12.612 4.05143 12.5624 4.1134 12.4999C4.17589 12.438 4.22549 12.3642 4.25933 12.283C4.29318 12.2017 4.3106 12.1146 4.3106 12.0266C4.3106 11.9386 4.29318 11.8515 4.25933 11.7702C4.22549 11.689 4.17589 11.6152 4.1134 11.5533L1.74007 9.1666H15.3334C15.5102 9.1666 15.6798 9.09636 15.8048 8.97134C15.9298 8.84631 16.0001 8.67674 16.0001 8.49993C16.0001 8.32312 15.9298 8.15355 15.8048 8.02853C15.6798 7.9035 15.5102 7.83327 15.3334 7.83327H1.70007L4.1134 5.41993C4.2316 5.29595 4.29753 5.13123 4.29753 4.95993C4.29753 4.78864 4.2316 4.62392 4.1134 4.49993C4.05143 4.43745 3.97769 4.38785 3.89646 4.35401C3.81522 4.32016 3.72808 4.30273 3.64007 4.30273C3.55206 4.30273 3.46493 4.32016 3.38369 4.35401C3.30245 4.38785 3.22871 4.43745 3.16674 4.49993L0.586738 7.0666C0.212203 7.4416 0.00183105 7.94993 0.00183105 8.47993C0.00183105 9.00993 0.212203 9.51827 0.586738 9.89327Z",
    fill: "#20BF6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_5792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.720c0ec8fa7c4ca40f9f118483d8a58a.svg";
export { ForwardRef as ReactComponent };